import PropTypes from "prop-types";

// MUI
import { Button, Grid, Typography } from "@mui/material";

export default function IconTextButton(props) {
	const { icon, text, buttonText, onButtonClick } = props;
	return (
		<Grid container direction="column" rowSpacing={3} alignItems="center" width={"580px"} paddingX={5} paddingBottom={5}>
			<Grid item>{icon}</Grid>
			<Grid item xs={12}>
				<Typography className={"regular-montserrat-label fs-16"} sx={{ textAlign: "center" }}>
					{text}
				</Typography>
			</Grid>
			<Grid item>
				<Button
					sx={{ minWidth: "250px", minHeight: "40px", backgroundColor: "#2357BE" }}
					id="general-dialog-option-btn"
					variant="contained"
					disabled={false}
					aria-controls="general-dialog-option-btn"
					className={"btn-regular-text"}
					onClick={onButtonClick}
				>
					<Typography className="regular-montserrat-label fs-16" sx={{ color: "white !important" }}>
						{buttonText}
					</Typography>
				</Button>
			</Grid>
		</Grid>
	);
}

IconTextButton.propTypes = {
	icon: PropTypes.element.isRequired,
	text: PropTypes.string.isRequired,
	buttonText: PropTypes.string.isRequired,
	onButtonClick: PropTypes.func.isRequired,
};
